import PageLayout from '@/shared/components/PageLayout';
import {PAGE_NAME, STATUS_BAR_COLOR} from '@/shared/constants/statusBarColor';

const CardGroupSkeleton = () => {
  return (
    <PageLayout
      tiara={false}
      className="container-card type_skeleton"
      statusBarColor={{default: STATUS_BAR_COLOR[PAGE_NAME.CARD_GROUP]}}
      headerProps={{buttons: [{type: 'CLOSE'}, {type: 'COMBOBOX', options: []}]}}
    >
      <div className="area_card">
        <div className="wrap_card">
          <div className="item_card"></div>
        </div>
      </div>
    </PageLayout>
  );
};
export default CardGroupSkeleton;
